(() => {
  'use strict';

  if (window.AustraliaRepeatTest) {
    window.AustraliaRepeatTest.init(document);
    return;
  }

  const rootSelector = '[data-av-repeat-test]';
  const stageSelector = ':scope > [data-av-repeat-stage]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const threshold = window.matchMedia('(max-width: 749px)').matches ? 0.4 : 0.5;
  let observer;

  const reveal = (stage) => {
    stage.classList.add('esta-visivel');
    observer?.unobserve(stage);
  };

  const makeObserver = () => {
    if (observer || reducedMotion.matches || saveData || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= threshold) reveal(entry.target);
      });
    }, { threshold });
    return observer;
  };

  const initRoot = (root) => {
    if (root.dataset.avRepeatReady === 'true') return;
    root.dataset.avRepeatReady = 'true';

    const stages = [...root.querySelectorAll(stageSelector)];
    const activeObserver = makeObserver();
    if (!activeObserver || stages.length !== 5) return;

    root.classList.add('is-enhanced');
    stages.forEach((stage) => activeObserver.observe(stage));
  };

  const init = (scope = document) => {
    if (scope.matches?.(rootSelector)) initRoot(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initRoot);
  };

  window.AustraliaRepeatTest = { init };
  init(document);

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.(stageSelector).forEach((stage) => observer?.unobserve(stage));
  });
})();